<template>
  <v-row>
    <v-col>
      <v-expansion-panel-content>
        <v-row>
          <v-col
            cols="6"
            sm="4"
            md="2"
          >
            <v-text-field
              v-model="screen.order"
              label="Порядковый номер экрана"
              type="number"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.background"
              label="Цвет фона"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.toolbar"
              label="Цвет тулбара"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logo"
              label="Логотип"
              :btn_text="'Загрузить фотографию'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoWidth"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoHeight"
              label="Высота изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-checkbox
              v-model="screen.logoOnly"
              label="Изображение - во весь экран"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logo2"
              label="Лого для вида оплаты картой"
              :btn_text="'лого для вида оплаты картой'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo2Width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo2Height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logo3"
              label="Лого для вида оплаты QR"
              :btn_text="'лого для вида оплаты QR'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo3Width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo3Height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logo4"
              label="Лого для вида оплаты наличные"
              :btn_text="'лого для вида оплаты наличные'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo4Width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo4Height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logo5"
              label="Лого для вида оплаты карта сотрудника"
              :btn_text="'лого для вида оплаты карта сотрудника'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo5Width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo5Height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logo6"
              label="Лого для вида оплаты Сканирование QR"
              :btn_text="'лого для вида оплаты Сканирование QR'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo6Width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo6Height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            Текст над видами оплаты
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.text.text"
              label="Текст"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            Текст под видами оплаты
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text2.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text2.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.text2.text"
              label="Текст"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <strong>Кнопка Отмена</strong>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="screen.button.radius"
              label="Размер радиуса"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.button.text.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.button.text.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.button.background"
              label="Цвет фона"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.button.label"
              label="Кнопка Отмена"
            />
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-col>
  </v-row>
</template>

<style>

</style>
<script>
import { posPointChoosePaymentScreen } from "@/views/loyalty/models/justpay-configuration-interface.model"

export default {
  name: 'SetupPospointChoosePaymentScreen',
  model: {
    prop: "screen",
    event: "changeScreen",
  },
  props: {
    confType: {
      type: Number,
      default: 0
    },
    screen: {
      default: () => (posPointChoosePaymentScreen)
    },
  },
  watch: {
    screen () {
      this.$emit('changeScreen', this.screen)
    }
  },
}
</script>
